import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import { FiltersGrid, Pagination } from '@/features/types';
import {
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import {
  CommercialMeteringPointFull,
  ContractCommercialMeteringPoint,
} from './types';

export const commercialMeteringPointsApi = createApi({
  reducerPath: 'commercialMeteringPointsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/commercial-metering-points`,
  }),
  tagTypes: [
    'ContractCommercialMeteringPoints',
    'ContractCommercialMeteringPoint',
  ],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getCommercialMeteringPointsByContractId: builder.infiniteQuery<
      ContractCommercialMeteringPoint[],
      FiltersGrid & { contractId: string; name?: string },
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: `/by-contract`,
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: ['ContractCommercialMeteringPoints'],
    }),

    getCommercialMeteringPointsById: builder.query<
      CommercialMeteringPointFull,
      string
    >({
      query: id => ({ url: `/${id}` }),
      providesTags: ['ContractCommercialMeteringPoint'],
    }),
  }),
});

export const {
  useGetCommercialMeteringPointsByIdQuery,
  useLazyGetCommercialMeteringPointsByIdQuery,
} = commercialMeteringPointsApi;

export const useGetCommercialMeteringPointsByContractIdInfiniteQuery =
  normalizeInfiniteQueryData(
    commercialMeteringPointsApi.useGetCommercialMeteringPointsByContractIdInfiniteQuery,
  );
